import { render } from "./TweetList.vue?vue&type=template&id=61efa417"
import script from "./TweetList.vue?vue&type=script&lang=js"
export * from "./TweetList.vue?vue&type=script&lang=js"

import "./TweetList.vue?vue&type=style&index=0&id=61efa417&lang=scss"

import exportComponent from "C:\\Users\\guada\\OneDrive\\Documents\\GitHub\\simulador-tweets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__